(() => {
  if (window.__npTaupeTowel) return;
  window.__npTaupeTowel = true;
  const d = document.createElement("dialog");
  d.className = "np-zoom";
  d.innerHTML = '<button type="button" aria-label="Close enlarged image">Close</button>';
  document.body.append(d);
  d.querySelector("button").onclick = () => d.close();
  d.addEventListener("click", (e) => { if (e.target === d) d.close(); });
  document.addEventListener("click", (e) => {
    const a = e.target.closest("[data-np-zoom]");
    if (!a) return;
    e.preventDefault();
    let img = d.querySelector("img");
    if (!img) {
      img = document.createElement("img");
      d.append(img);
    }
    img.src = a.href;
    img.alt = (a.querySelector("img") || {}).alt || "Enlarged product view";
    d.showModal();
  });
  const scrollToId = (id) => {
    const target = document.getElementById(id) || (id === "me-purchase" ? document.querySelector("[data-me-purchase]") : null);
    if (!target) return false;
    document.querySelectorAll(".np-film video").forEach((video) => video.blur());
    if (document.activeElement && document.activeElement.blur) document.activeElement.blur();
    const se = document.scrollingElement || document.documentElement;
    const top = Math.max(0, target.getBoundingClientRect().top + se.scrollTop - 110);
    se.scrollTop = top;
    se.scrollTo(0, top);
    window.scrollTo(0, top);
    try { history.replaceState({}, "", "#" + id); } catch (_) {}
    return true;
  };
  document.querySelectorAll('a[href="#me-purchase"], a[href="#np-film"]').forEach((link) => {
    link.addEventListener("click", (event) => {
      const id = (link.getAttribute("href") || "").replace("#", "");
      if (scrollToId(id)) event.preventDefault();
    });
  });
  document.querySelectorAll(".np-film video").forEach((video) => {
    video.addEventListener("click", () => {
      if (video.paused) video.play(); else video.pause();
    });
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      video.pause();
      video.removeAttribute("autoplay");
    }
  });
  document.querySelectorAll(".me-tax").forEach((n) => {
    n.textContent = "Standard shipping included to the contiguous US + DC. Sales tax at checkout.";
  });
})();
